import { t } from 'i18next';
import Iconify from 'src/components/iconify';

// ----------------------------------------------------------------------

export const navConfig = [
  {
    title: 'string_124',
    icon: <Iconify icon="tabler:arrow-right" />,
    path: '/',
  },
  {
    title: 'string_125',
    icon: <Iconify icon="tabler:arrow-right" />,
    path: '/sr-foundation',
  },
  {
    title: 'string_126',
    icon: <Iconify icon="tabler:arrow-right" />,
    path: '/sr-ventures',
  },
  {
    title: 'string_127',
    icon: <Iconify icon="tabler:arrow-right" />,
    path: '/sr-liquidity',
  },
  {
    title: 'string_128',
    icon: <Iconify icon="tabler:arrow-right" />,
    path: '/about',
  },
  {
    title: 'string_129',
    icon: <Iconify icon="tabler:arrow-right" />,
    path: '/team',
  },
];
